import { render, staticRenderFns } from "./FooterRzaska.vue?vue&type=template&id=faa5c6a6&"
import script from "./FooterRzaska.vue?vue&type=script&lang=js&"
export * from "./FooterRzaska.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports